<template>
  <div class="mainpage">
    <!--<div class="top_banner">Banner Top</div>-->
    <div class="columns">
      <div class="column is-one-third is_padding">
        <div class="box" id="box1">
  <article class="media">
    <div class="media-left">
      <figure class="image is-64x64">
        <img src="pos.png" alt="Image">
      </figure>
    </div>
    <div class="media-content">
      <div class="content thefont2">
        <p>
          <strong>Coordinates</strong>
          <br>This tool helps you to get the coorinates of points of your interest.
          <br>The positions are plotted in a map and saved in a CSV file.
          <br><a href="http://www.sramp.com">Brought to you by www.sramp.com</a> 
          <br>
        </p>
      </div>
    </div>
  </article>
</div>
 
  <div class="box is_padding"  id="box3">
   <app-switch classes="is-warning" v-model="switch_value" checked>DD / DMS</app-switch>
    <p>
      &nbsp
      </p>
    <VueScrollTable :options="options" :columns="columns" :rows="rows" :selectedItem="selectedItem"></VueScrollTable>

    <div class="columns">
       <div class="column">
       <template v-if="rows.length>0">
      <a class="button is-small is-info is-pulled-left" @click="doExport()">Export</a>
       </template>
       </div>
         <div class="column has-text-centered is-narrow">
        <template v-if="sel_id>=0">
        <a class="button is-small is-info" @click="doShowAll()">Show All</a>
        </template>
         </div>
         <div class="column">
       <template v-if="rows.length>0">
       <a class="button is-small  is-danger is-pulled-right" @click="doDeleteLast()">Delete Last</a>
       </template>   
         </div>
         </div>
  </div>
      </div>
      <div class="column">
      <GmapMap ref="mmm" id="gmap" :center=center :zoom="7" :options="{draggableCursor:'crosshair'}" @click="clicked"> 
          <gmap-marker v-for="m in rows" :key="m.id" :position="{lat:parseFloat(m.lat), lng:parseFloat(m.lon)}" :z-index="1000" :clickable="false"  :draggable="false" :icon="getIcon(m,m.id==sel_id)">
           </gmap-marker>
      </GmapMap>
      </div>
    </div>
    <modal name="edit_note" :width="400" :height="110" :draggable="true">
                <div class="edit_note">
                    <div  class="is-padding">
                    <table>
                    <tr><td width="100">#</td><td width="300">{{edit_row.id}}</td></tr>
                    <tr><td>Lat</td><td>{{edit_row.lat}}</td></tr>
                    <tr><td>Lon</td><td>{{edit_row.lon}}</td></tr>
                    </table>
                    </div>
               <div class="columns is-padding">
                  <div class="column">
                         <input name="note" class="input" type="text" placeholder="note"  v-model="edit_note" >
                  </div>
                  <div class="column is-narrow">
                     <a class="button  is-info" @click="doEdit()">OK</a>
                  </div>
               </div>
              </div>
   </modal>
    <div class="bottom_banner_wrapper">
    <div class="bottom_banner">
      <adsense/>
    </div>
    </div>
  </div>
</template>
<script>
import VueScrollTable from './VueScrollTable.vue'
 import Switch from './Switch.vue'
import adsense from './VueAdsense.vue'
 import {UtilityMixin} from '../mixins/UtilityMixin.js';
export default {
   name: 'CoordPage',
   mixins: [UtilityMixin],
   data: function() {
     return {
             switch_value: false,
             switch_text: 'DMS',
            api_server:"https://www.sramp.com/tools_/",
              download:null,
      nmeaCode:"",
     clickRow:null,
      center:{lat:51, lng:0},
         edit_is_on:false,
         sel_id:-1,
         edit_note:"",
         edit_row:{},
         selectedItem:null,
         rows: [],
         columns: [],
        options: {
          id:"LS002",
          isResizeable: true,
          isSelectable: true,
          cssContainer: "",
          cssHeader: "table_list_header",
          cssBody: "table_list",
          cssRows: "table_list",
          order_col: "id"
        } 
            }
    },
     components: {
        VueScrollTable,
              adsense,
              'app-switch': Switch
    },
        watch: {
            switch_value(val) {
                this.switch_text = val ? 'DMS' : 'DD'
                if(this.switch_text=="DD"){
                      this.columns[1].filter=""
                       this.columns[2].filter=""
                }
                else
                {
                this.columns[1].filter="DD2DMS_lat"
                       this.columns[2].filter="DD2DMS_lon"
                }
            }
        },
 mounted(){
       this.$nextTick(function() {
          const vm=this;

          window.addEventListener('resize', vm.getWindowHeight)
          vm.getWindowHeight()
          vm.initColumns()
        })
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.getWindowHeight)
  },
  methods:{
    
        doShowAll(){
            const vm=this
            vm.centerAllMarkers()
        },
         doDeleteLast(){

            const vm=this
            var deleted=vm.rows.pop()
            console.log(deleted)
         },
         initColumns() {
        var vm = this
        var columns = [
                        {id:"id",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "ID",alignment_th: 'left_align',alignment_td: 'right_align',width: 40,elastic: false,filter: "",order: 0,image: false},
                        {id:"lat",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Lat",alignment_th: 'left_align',alignment_td: 'center_align',width:140,elastic: false,filter: "DD2DMS_lat",order: -1,image: false},
                        {id:"lon",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Lon",alignment_th: 'left_align',alignment_td: 'center_align',width:140,elastic: false,filter: "DD2DMS_lon",order: -1,image: false},
                        {id:"note",visible: true,f_type_id:"",f_type:"*",title: "note",width:50,alignment_th: 'left_align',alignment_td: 'right_align',elastic: true,filter: "num.#",image: false}
                     ]

        vm.columns=columns
      },
   doEdit(){
       const vm=this
       vm.edit_row.note=vm.edit_note
        vm.$modal.hide('edit_note');
   },
    colClick(id,col,row){
        const vm=this
        if (col.id=="note"){
         vm.edit_note=row.note
         vm.edit_row=row
         vm.$modal.show('edit_note');
        }
        else{
        vm.sel_id=row.id
        vm.selectedItem=row
        vm.centerMarker(row)
        }
      },
     clicked(event){
         const vm=this
         var aRow={}
         aRow.id=vm.rows.length+1;
         aRow.lat=event.latLng.lat()
         aRow.lon=event.latLng.lng()
         aRow.note=""
         vm.rows.push(aRow)
      },
     getWindowHeight(event) {
                const vm=this
                vm.windowHeight = document.documentElement.clientHeight;
                document.getElementById("gmap").setAttribute("style", "height:" + (vm.windowHeight -150) + 'px')
               vm.calcSizeBoxes()
            },
      calcSizeBoxes(){
          const vm=this
           var ele=document.getElementById("gmap")
           var gmap_height=ele.clientHeight;
           ele=document.getElementById("box1");
           var box1_height=ele.clientHeight;  
           document.getElementById("box3").setAttribute("style", "height:" + (gmap_height - (box1_height +30)) + 'px')
           document.getElementById(vm.options.id+"bw").setAttribute("style", "height:" + (gmap_height - (box1_height+200)) + 'px') 
      },
          getIcon(obj,isSelected) {
                const vm=this
                var colorMode = 'rgb(0,255,0)'
                var color = (isSelected ? 'rgb(255,0,0)' : 'rgb(51,204,51)')
                var myIcon
               
                var offset = (obj.id>9 ? 10:12)
                var mySvg = 'data:image/svg+xml;utf-8, \
      <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"> \
      <polyline points="1,1  29,1  29,20 20,20 15,29 10,20 1,20 1,0" style="stroke:' + colorMode + '; stroke-width: 2; fill: ' + color + ';"/>\
       <text x="'+offset+'" y="14" fill="black"  font-size="10">' + obj.id + '</text></svg>'
                myIcon = {
                    url: mySvg,
                    anchor: new google.maps.Point(15, 30),
                    size: new google.maps.Size(30, 30)
                }
                return myIcon;
            }
       ,
       
        async doExport(){
          const vm = this
          var response
          var fd = new FormData();
          var BOM = "\uFEFF"
          var data=BOM+"#\tLat\tLon\tNote\r\n"
          const ava ="\t"
          const crlf="\r\n"
          var lat
          var lon
          for (var i=0; i<vm.rows.length; i++){
            if (vm.switch_text=="DD"){
                lat=vm.rows[i].lat
                lon=vm.rows[i].lon
            }
            else
            {
                lat=vm.ddToDms_lat(vm.rows[i].lat)
                lon=vm.ddToDms_lon(vm.rows[i].lon)
            }
            data=data+vm.rows[i].id+ava+lat+ava+lon+ava+vm.rows[i].note+crlf
          }
          
    const url = window.URL.createObjectURL(new Blob([data], {type : "text/csv;charset=iso-8859-1"}))
   const link = document.createElement('a')
   link.href = url;
   link.setAttribute('download', 'file_coords.csv'); //or any other extension
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
   window.URL.revokeObjectURL(url);
        }
  }
}
</script>
